"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_fs = require("fs");
var import_os = require("os");
var import_path = require("path");
var import_fs_extra = __toESM(require("fs-extra"), 1);
var import_vitest = require("vitest");
var import_buildOutputPointer = require("./buildOutputPointer");
(0, import_vitest.describe)("build output pointer", function() {
  var originalCwd = process.cwd();
  var tempRoot = "";
  (0, import_vitest.beforeEach)(function() {
    tempRoot = (0, import_fs.mkdtempSync)((0, import_path.join)((0, import_os.tmpdir)(), "one-build-pointer-"));
    process.chdir(tempRoot);
  });
  (0, import_vitest.afterEach)(async function() {
    process.chdir(originalCwd);
    import_vitest.vi.restoreAllMocks();
    await import_fs_extra.default.remove(tempRoot);
  });
  (0, import_vitest.it)("prefers an explicit serve outDir", async function() {
    await import_fs_extra.default.ensureDir("build-out");
    await import_fs_extra.default.writeJSON((0, import_path.join)("build-out", "buildInfo.json"), {});
    await (0, import_buildOutputPointer.writeBuildOutputPointer)("build-out");
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)("manual-out")).toBe("manual-out");
  });
  (0, import_vitest.it)("preserves serving from inside the output directory", async function() {
    await import_fs_extra.default.writeJSON("buildInfo.json", {});
    await import_fs_extra.default.ensureDir("build-out");
    await import_fs_extra.default.writeJSON((0, import_path.join)("build-out", "buildInfo.json"), {});
    await (0, import_buildOutputPointer.writeBuildOutputPointer)("build-out");
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)()).toBe(".");
  });
  (0, import_vitest.it)("resolves the outDir written by build", async function() {
    await import_fs_extra.default.ensureDir("build-out");
    await import_fs_extra.default.writeJSON((0, import_path.join)("build-out", "buildInfo.json"), {});
    await (0, import_buildOutputPointer.writeBuildOutputPointer)("build-out");
    (0, import_vitest.expect)(await import_fs_extra.default.readJSON(import_buildOutputPointer.buildOutputPointerPath)).toEqual({
      outDir: "build-out"
    });
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)()).toBe("build-out");
  });
  (0, import_vitest.it)("falls back to dist when the pointer is stale", async function() {
    var warn = import_vitest.vi.spyOn(console, "warn").mockImplementation(function() {
    });
    await (0, import_buildOutputPointer.writeBuildOutputPointer)("missing-out");
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)()).toBe("dist");
    (0, import_vitest.expect)(warn).toHaveBeenCalledTimes(2);
    (0, import_vitest.expect)(warn.mock.calls[0][0]).toMatch(/build-pointer\.json points to/);
    (0, import_vitest.expect)(warn.mock.calls[1][0]).toMatch(/no build-output pointer/);
  });
  (0, import_vitest.it)("falls back to dist when no pointer exists and warns about missing dist", async function() {
    var warn = import_vitest.vi.spyOn(console, "warn").mockImplementation(function() {
    });
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)()).toBe("dist");
    (0, import_vitest.expect)(warn).toHaveBeenCalledOnce();
    (0, import_vitest.expect)(warn.mock.calls[0][0]).toMatch(/no build-output pointer/);
  });
  (0, import_vitest.it)("does not warn when falling back to an existing dist/ build", async function() {
    var warn = import_vitest.vi.spyOn(console, "warn").mockImplementation(function() {
    });
    await import_fs_extra.default.ensureDir("dist");
    await import_fs_extra.default.writeJSON((0, import_path.join)("dist", "buildInfo.json"), {});
    (0, import_vitest.expect)(await (0, import_buildOutputPointer.resolveServeOutDir)()).toBe("dist");
    (0, import_vitest.expect)(warn).not.toHaveBeenCalled();
  });
  (0, import_vitest.it)("warns when the pointer write fails", async function() {
    var warn = import_vitest.vi.spyOn(console, "warn").mockImplementation(function() {
    });
    var writeSpy = import_vitest.vi.spyOn(import_fs_extra.default, "writeJSON").mockRejectedValueOnce(new Error("permission denied"));
    await (0, import_buildOutputPointer.writeBuildOutputPointer)("build-out");
    (0, import_vitest.expect)(writeSpy).toHaveBeenCalled();
    (0, import_vitest.expect)(warn).toHaveBeenCalledOnce();
    (0, import_vitest.expect)(warn.mock.calls[0][0]).toMatch(/could not write build-output pointer/);
  });
});
//# sourceMappingURL=buildOutputPointer.test.js.map
